<!-- ═══════════════════════════════════════ -->
<!--  AGREGAR PERMISOS DESDE LA PANTALLA     -->
<!--  Ruta → pantalla real en modo marcador (pantalla completa) → tocar → Matriz de Permisos -->
<!-- ═══════════════════════════════════════ -->
<!-- Indicador de pasos -->
<ng-template #pasosTpl let-compacto="compacto">
  <ol class="m-0 flex list-none items-center gap-2 p-0 text-sm" aria-label="Pasos">
    <ng-container *ngFor="let p of pasosVista; let i = index; let ultimo = last">
      <li class="flex items-center gap-2" [attr.aria-current]="p.actual ? 'step' : null">
        <span class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-semibold"
          [ngClass]="p.hecho ? 'bg-indigo-600 text-white' : (p.actual ? 'border-2 border-indigo-600 text-indigo-700' : 'border border-gray-300 text-gray-500')">
          <i *ngIf="p.hecho" class="fas fa-check text-[10px]"></i><span *ngIf="!p.hecho">{{ p.numero }}</span>
        </span>
        <span [ngClass]="p.actual ? 'font-semibold text-gray-900' : 'text-gray-500'" [class.hidden]="compacto && !p.actual" [class.md:inline]="compacto && !p.actual">{{ p.titulo }}</span>
      </li>
      <li *ngIf="!ultimo" aria-hidden="true" class="h-px w-6 bg-gray-300 sm:w-10"></li>
    </ng-container>
  </ol>
</ng-template>

<div class="space-y-6">

  <!-- Paso 1: la ruta -->
  <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
    <div class="p-6 space-y-4">
      <div class="flex flex-wrap items-start justify-between gap-4">
        <div class="min-w-0">
          <h3 class="text-lg font-semibold">Agregar permisos desde la pantalla</h3>
          <p class="text-sm text-muted-foreground mt-1">
            Elige una pantalla, toca lo que quieres proteger y guarda: queda en la Matriz de Permisos.
          </p>
        </div>
        <ng-container *ngTemplateOutlet="pasosTpl; context: { compacto: false }"></ng-container>
      </div>

      <!-- Cargando / error de los módulos -->
      <div *ngIf="cargando" class="text-sm text-gray-500">
        <i class="fas fa-spinner fa-spin mr-2 text-blue-500"></i>Cargando los módulos de la matriz...
      </div>
      <div *ngIf="!cargando && errorCarga" class="text-sm text-red-600">
        <i class="fas fa-exclamation-triangle mr-2"></i>{{ errorCarga }}
        <button type="button" (click)="cargarPantallas()" class="ml-3 underline">Reintentar</button>
      </div>

      <div *ngIf="!cargando && !errorCarga" class="max-w-xl space-y-2">
        <label for="agregar-ruta" class="block text-xs font-semibold uppercase tracking-wide text-gray-500">Ruta de la pantalla</label>

        <!-- Sin pantalla abierta: campo con sugerencias -->
        <ng-container *ngIf="!hayPantalla">
          <input id="agregar-ruta" type="text" autocomplete="off"
            [(ngModel)]="consulta" (ngModelChange)="alEscribirRuta()"
            placeholder="Escribe parte de la ruta, por ejemplo «tasas»"
            class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
          <div *ngIf="sugerencias.length" class="rounded-md border border-gray-200 bg-white overflow-hidden shadow-sm">
            <button type="button" *ngFor="let r of sugerencias" (click)="elegirRuta(r)"
              class="flex w-full flex-wrap items-baseline justify-between gap-x-3 px-3 py-2 text-left text-sm hover:bg-blue-50">
              <span class="font-medium">{{ nombreMatrizDe(r) || r.nombre }}</span>
              <code class="w-full text-[11px] text-gray-400 break-all">{{ r.ruta }}</code>
            </button>
          </div>
          <p *ngIf="!sugerencias.length && !pidiendoValores" class="text-xs text-gray-500">
            Aparecen solo las rutas que existen en la consola (desde 2 letras).
          </p>
          <p *ngIf="consulta.trim().length >= 2 && !sugerencias.length && !pidiendoValores && !rutaElegida" class="text-xs text-amber-600">
            No hay ninguna ruta de la consola que coincida con lo que escribiste.
          </p>
        </ng-container>

        <!-- Con pantalla abierta: la ruta queda fija y se puede cambiar -->
        <div *ngIf="hayPantalla" class="flex flex-wrap items-center gap-3">
          <code id="agregar-ruta" class="rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-sm break-all">{{ rutaAbierta }}</code>
          <button type="button" (click)="cambiarPantalla()"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-gray-300 bg-white hover:bg-gray-50 h-9 px-4 transition-colors">
            <i class="fas fa-exchange-alt mr-2"></i>Cambiar de pantalla
          </button>
        </div>

        <!-- La ruta lleva un dato que cambia (:code): pide un valor de ejemplo antes de abrirla -->
        <div *ngIf="pidiendoValores && rutaElegida" class="rounded-md border border-amber-300 bg-amber-50 p-3 space-y-3">
          <p class="text-sm text-amber-900">
            Esta pantalla muestra datos de un registro concreto. Escribe un valor de ejemplo (por ejemplo un código que exista) para poder abrirla.
            La marca va a valer para cualquier valor: queda guardada como <code class="text-xs break-all">{{ rutaElegida.ruta }}</code>.
          </p>
          <div *ngFor="let p of rutaElegida.parametros" class="space-y-1">
            <label [for]="'agregar-param-' + p" class="block text-xs font-semibold uppercase tracking-wide text-gray-500">¿Qué registro abrimos de ejemplo?</label>
            <input [id]="'agregar-param-' + p" type="text" autocomplete="off" [(ngModel)]="valores[p]" (keydown.enter)="abrirPantalla()"
              class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
            <p class="text-xs text-gray-500">{{ ayudaParametro(p) }}</p>
          </div>
          <button type="button" (click)="abrirPantalla()" [disabled]="parametrosPendientes.length > 0"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-indigo-600 text-white hover:bg-indigo-700 h-9 px-4 disabled:opacity-50 transition-colors">
            <i class="fas fa-external-link-alt mr-2"></i>Abrir pantalla
          </button>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="hayPantalla && estado">

    <!-- La pantalla marcada: en pantalla completa (capa fija) o dentro de la pestaña. Es el mismo bloque, solo cambian las clases: el iframe no se recarga. -->
    <div [style.margin]="pantallaCompleta ? '0' : null" [ngClass]="pantallaCompleta ? 'fixed inset-0 z-[10000] flex flex-col overflow-y-auto bg-gray-50 lg:overflow-hidden' : 'flex flex-col overflow-hidden rounded-lg border bg-card text-card-foreground shadow-sm'">

      <!-- Barra superior -->
      <div class="flex shrink-0 flex-wrap items-center gap-x-4 gap-y-2 border-b border-gray-200 bg-white px-4 py-2.5">
        <code class="max-w-[18rem] truncate rounded-md border border-gray-200 bg-gray-50 px-2 py-1 text-xs text-gray-700" [title]="rutaAbierta">{{ rutaAbierta }}</code>
        <ng-container *ngTemplateOutlet="pasosTpl; context: { compacto: true }"></ng-container>
        <div class="inline-flex overflow-hidden rounded-md border border-gray-200" role="group" aria-label="Qué hacen los clics en la pantalla">
          <button type="button" (click)="cambiarModo('marcar')" [attr.aria-pressed]="modoMarcador === 'marcar'"
            class="h-8 px-3 text-xs font-medium transition-colors"
            [ngClass]="modoMarcador === 'marcar' ? 'bg-indigo-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'">Marcar</button>
          <button type="button" (click)="cambiarModo('usar')" [attr.aria-pressed]="modoMarcador === 'usar'"
            class="h-8 border-l border-gray-200 px-3 text-xs font-medium transition-colors"
            [ngClass]="modoMarcador === 'usar' ? 'bg-indigo-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'">Usar la pantalla</button>
        </div>
        <span *ngIf="modoMarcador === 'marcar'" class="text-xs font-medium text-gray-600"><i class="fas fa-crosshairs mr-1.5 text-indigo-600"></i>Modo marcador · los clics no ejecutan nada</span>
        <span *ngIf="modoMarcador === 'usar'" class="text-xs font-medium text-gray-600"><i class="fas fa-hand-pointer mr-1.5 text-indigo-600"></i>Usar la pantalla · abre menús o pestañas; nada se guarda</span>
        <span class="ml-auto inline-flex items-center rounded-full border border-gray-200 bg-gray-50 px-2.5 py-0.5 text-xs font-medium text-gray-700">{{ textoContador }}</span>
        <button *ngIf="!pantallaCompleta" type="button" (click)="entrarPantallaCompleta()"
          class="inline-flex h-8 items-center justify-center rounded-md bg-indigo-600 px-3 text-sm font-medium text-white transition-colors hover:bg-indigo-700">
          <i class="fas fa-expand mr-2"></i>Pantalla completa
        </button>
        <button *ngIf="pantallaCompleta" type="button" (click)="salirPantallaCompleta()" title="Esc"
          class="inline-flex h-8 items-center justify-center rounded-md border border-gray-300 bg-white px-3 text-sm font-medium transition-colors hover:bg-gray-50">
          <i class="fas fa-compress mr-2"></i>Salir de pantalla completa
        </button>
      </div>
      <p class="m-0 shrink-0 border-b border-gray-200 bg-gray-50 px-4 py-1.5 text-xs text-gray-500">
        Algunas pantallas cargan sus datos de una forma que el modo marcador frena; si ves la pantalla vacía, igual puedes marcar sus botones.
      </p>
      <p *ngIf="rutaDesviada" role="alert" class="m-0 shrink-0 border-b border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-900">
        <i class="fas fa-exclamation-triangle mr-1"></i>{{ textoRutaDesviada }}
      </p>

      <div class="flex min-h-0 flex-1 flex-col lg:flex-row" [class.lg:h-[80vh]]="!pantallaCompleta">

        <!-- La pantalla -->
        <div class="flex min-w-0 flex-1 flex-col bg-gray-100 p-3">
          <iframe #marcador name="rbac-marcador" [src]="urlMarcador" title="Pantalla en modo marcador"
            class="block min-h-[480px] w-full flex-1 rounded-md border border-gray-200 bg-white"></iframe>
        </div>

        <!-- Panel de la derecha -->
        <aside class="flex w-full shrink-0 flex-col border-t border-gray-200 bg-white lg:min-h-0 lg:w-[380px] lg:border-l lg:border-t-0" aria-label="Lo que vas a agregar">
          <div class="space-y-6 p-4 lg:min-h-0 lg:flex-1 lg:overflow-y-auto">

            <!-- 1 · Esta pantalla -->
            <section class="space-y-2">
              <h4 class="m-0 text-[11px] font-semibold uppercase tracking-wide text-gray-500">Esta pantalla</h4>

              <!-- Ya está en la matriz -->
              <ng-container *ngIf="estado.filaExistente">
                <p class="m-0 text-sm"><span class="font-semibold">{{ estado.filaExistente.nombre }}</span><span class="text-gray-500"> · en {{ pantallaActual?.nombre }}</span></p>
              </ng-container>

              <!-- Pantalla nueva en la matriz -->
              <ng-container *ngIf="!estado.filaExistente">
                <div class="flex items-center gap-2">
                  <label for="agregar-nombre" class="shrink-0 text-sm text-gray-500">Pantalla nueva:</label>
                  <input id="agregar-nombre" type="text" autocomplete="off" [(ngModel)]="estado.nombre" [disabled]="!!resultado"
                    class="flex h-8 min-w-0 flex-1 rounded-md border border-input bg-background px-2 py-1 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-1 disabled:opacity-60">
                </div>
                <p class="m-0 text-sm text-gray-500">en {{ pantallaActual?.nombre }} · {{ lugarTexto }}</p>
              </ng-container>

              <!-- Sus opciones de hoy -->
              <div class="flex flex-wrap gap-1" aria-label="Opciones de esta pantalla">
                <ng-container *ngIf="estado.filaExistente">
                  <span *ngFor="let c of estado.filaExistente.casillas"
                    class="inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-700">{{ c.nombre }}</span>
                </ng-container>
                <span *ngIf="!estado.filaExistente" class="inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-700">Consultar</span>
              </div>

              <!-- Cambiar dónde aparece (solo la pantalla nueva) -->
              <details *ngIf="!estado.filaExistente && !resultado" class="text-sm">
                <summary class="cursor-pointer text-xs text-indigo-600 hover:underline">Cambiar dónde aparece</summary>
                <div class="mt-2 space-y-3">
                  <div class="space-y-1">
                    <label for="agregar-modulo" class="block text-xs text-gray-500">Módulo</label>
                    <select id="agregar-modulo" [ngModel]="creandoModulo ? moduloNuevo : estado.pantalla" (ngModelChange)="elegirModulo($event)"
                      class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
                      <option *ngFor="let p of pantallas" [value]="p.id">{{ p.nombre }}</option>
                      <option [value]="moduloNuevo">+ Nuevo módulo</option>
                    </select>
                  </div>

                  <!-- Módulo nuevo -->
                  <div *ngIf="creandoModulo" class="space-y-2">
                    <div class="space-y-1">
                      <label for="agregar-modulo-nombre" class="block text-xs text-gray-500">Nombre del módulo nuevo</label>
                      <input id="agregar-modulo-nombre" type="text" autocomplete="off" [(ngModel)]="nuevoModulo.nombre" (keydown.enter)="crearModulo()"
                        class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
                    </div>
                    <div class="space-y-1">
                      <label for="agregar-modulo-lugar" class="block text-xs text-gray-500">Dónde va el módulo</label>
                      <select id="agregar-modulo-lugar" [(ngModel)]="nuevoModulo.despuesDe"
                        class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
                        <option *ngFor="let p of pantallas" [value]="p.id">Después de «{{ p.nombre }}»</option>
                        <option value="">Al final</option>
                      </select>
                    </div>
                    <p *ngIf="errorModulo" class="m-0 text-xs text-red-600"><i class="fas fa-exclamation-circle mr-1"></i>{{ errorModulo }}</p>
                    <div class="flex gap-2">
                      <button type="button" (click)="crearModulo()" [disabled]="guardandoModulo"
                        class="inline-flex h-8 items-center justify-center rounded-md bg-indigo-600 px-3 text-xs font-medium text-white hover:bg-indigo-700 disabled:opacity-50">
                        <i *ngIf="guardandoModulo" class="fas fa-spinner fa-spin mr-2"></i>Crear módulo
                      </button>
                      <button type="button" (click)="cancelarModulo()"
                        class="inline-flex h-8 items-center justify-center rounded-md border border-gray-300 bg-white px-3 text-xs font-medium hover:bg-gray-50">Cancelar</button>
                    </div>
                  </div>

                  <div class="space-y-1">
                    <label for="agregar-lugar" class="block text-xs text-gray-500">Lugar en la matriz</label>
                    <select id="agregar-lugar" [(ngModel)]="estado.despuesDe" (ngModelChange)="alCambiarLugar()"
                      class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
                      <option *ngFor="let f of filasLugar" [value]="f.nombre">Después de «{{ f.nombre }}»</option>
                      <option value="">Al final del módulo</option>
                    </select>
                  </div>
                  <div *ngIf="gruposModulo.length && !estado.despuesDe" class="space-y-1">
                    <label for="agregar-grupo" class="block text-xs text-gray-500">Grupo dentro del módulo</label>
                    <select id="agregar-grupo" [(ngModel)]="estado.grupo"
                      class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
                      <option value="">Sin grupo</option>
                      <option *ngFor="let g of gruposModulo" [value]="g.id">{{ g.nombre }}</option>
                    </select>
                  </div>
                </div>
              </details>

              <!-- Alternar: fila que ya existe / sección aparte -->
              <button *ngIf="estado.filaExistente && !resultado" type="button" (click)="crearSubmoduloNuevo()" class="block text-xs text-indigo-600 hover:underline">
                ¿No va en «{{ estado.filaExistente.nombre }}»? Crear una fila nueva en la matriz
              </button>
              <button *ngIf="!estado.filaExistente && filaDetectada && !resultado" type="button" (click)="usarFilaExistente()" class="block text-xs text-indigo-600 hover:underline">
                Mejor ponerlo en «{{ filaDetectada.nombre }}»
              </button>
            </section>

            <!-- 2 · Lo que tocaste -->
            <section #formulario *ngIf="form && !resultado" class="space-y-3 border-t border-gray-200 pt-5">
              <h4 class="m-0 text-[11px] font-semibold uppercase tracking-wide text-gray-500">Lo que tocaste</h4>
              <p class="m-0 text-base font-semibold leading-snug">{{ queTocaste }}</p>
              <p *ngIf="notaCoincidencias" class="m-0 text-xs text-gray-600">{{ notaCoincidencias }}</p>
              <div *ngIf="form.huellaSolo && form.huellaTodos" class="flex flex-wrap gap-2 text-xs" role="group" aria-label="Alcance de la marca">
                <button type="button" (click)="elegirAlcance('solo')" [class.font-semibold]="form.alcance === 'solo'"
                  class="rounded-md border px-2 py-1" [ngClass]="form.alcance === 'solo' ? 'border-indigo-500 bg-indigo-50 text-indigo-700' : 'border-gray-300'">Solo este</button>
                <button type="button" (click)="elegirAlcance('todos')" [class.font-semibold]="form.alcance !== 'solo'"
                  class="rounded-md border px-2 py-1" [ngClass]="form.alcance !== 'solo' ? 'border-indigo-500 bg-indigo-50 text-indigo-700' : 'border-gray-300'">Todos los parecidos</button>
              </div>
              <div *ngIf="form.yaTiene?.length" class="rounded-md border border-amber-300 bg-amber-50 p-2 text-xs text-amber-900">
                <p class="m-0 font-medium">{{ textoYaTiene }}</p>
                <button *ngFor="let y of form.yaTiene" type="button" (click)="usarElMismo(y)" class="mt-1 block text-indigo-700 hover:underline">
                  Usar ese mismo ({{ y.texto }})
                </button>
              </div>

              <!-- Nombre sugerido (lo normal): se crea una casilla nueva en la matriz -->
              <div *ngIf="form.tipo !== 'accion' || form.modoPermiso !== 'existente'" class="space-y-1">
                <label for="agregar-form-nombre" class="block text-sm font-medium">Nombre</label>
                <input id="agregar-form-nombre" type="text" autocomplete="off" [(ngModel)]="form.nombre"
                  [attr.list]="form.tipo === 'accion' ? 'agregar-acciones-estandar' : null" (keydown.enter)="marcar()"
                  [attr.aria-invalid]="form.sinSugerencia && !form.nombre.trim() ? 'true' : null"
                  [ngClass]="form.sinSugerencia && !form.nombre.trim() ? 'border-red-400 ring-1 ring-red-300' : 'border-input'"
                  class="flex h-9 w-full rounded-md border bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
                <datalist id="agregar-acciones-estandar">
                  <option *ngFor="let a of accionesEstandar" [value]="a"></option>
                </datalist>
                <p *ngIf="form.sinSugerencia && !form.nombre.trim()" class="m-0 text-xs font-medium text-red-600">Ponle un nombre a este botón</p>
                <p class="m-0 text-xs text-gray-600">{{ textoDondeSeAgrega }}</p>
                <p *ngIf="form.tipo === 'accion' && form.casillaSugerida && !form.existente" class="m-0 text-xs text-gray-600">
                  Esta pantalla ya tiene la casilla «{{ form.casillaSugerida.nombre }}».
                  <button type="button" (click)="cambiarModoPermiso('existente')" class="text-indigo-600 hover:underline">Usar esa</button>
                </p>
                <button *ngIf="form.tipo === 'accion'" type="button" (click)="cambiarModoPermiso('existente')" class="block text-xs text-indigo-600 hover:underline">
                  Usar una casilla que ya existe
                </button>
              </div>

              <!-- Usar una casilla que ya existe (solo acciones): lo mismo que hacía «Los mismos que ya pueden…» -->
              <div *ngIf="form.tipo === 'accion' && form.modoPermiso === 'existente'" class="space-y-2">
                <ng-container *ngIf="form.permisoExistente && !buscandoOtraOpcion">
                  <p class="m-0 text-sm font-medium">
                    Lo tendrán los mismos que ya pueden {{ nombreOpcionElegida }}
                    <span *ngIf="form.casillaSugerida" class="ml-1 rounded-full bg-indigo-600 px-2 py-0.5 text-[10px] font-semibold uppercase text-white">Sugerido</span>
                  </p>
                  <p class="m-0 text-xs text-gray-600">{{ form.permisoTexto }}</p>
                  <button type="button" (click)="buscandoOtraOpcion = true" class="text-xs text-indigo-600 hover:underline">Elegir otra</button>
                </ng-container>
                <ng-container *ngIf="!form.permisoExistente || buscandoOtraOpcion">
                  <p class="m-0 text-xs text-gray-600">Busca la casilla de la matriz cuyo acceso quieres copiar.</p>
                  <input type="text" autocomplete="off" [ngModel]="busquedaPermiso" (ngModelChange)="busquedaPermiso = $event; filtrarPermisos()"
                    placeholder="Por ejemplo «Eliminar clientes»" aria-label="Buscar una casilla que ya existe"
                    class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
                  <div *ngIf="resultadosPermiso.length" class="max-h-56 overflow-y-auto rounded-md border border-gray-200 bg-white">
                    <button type="button" *ngFor="let c of resultadosPermiso" (click)="elegirPermiso(c)"
                      class="block w-full px-3 py-2 text-left text-sm hover:bg-indigo-50"
                      [class.bg-indigo-50]="esPermisoElegido(c)">{{ c.texto }}</button>
                  </div>
                  <p *ngIf="totalPermiso > resultadosPermiso.length" class="m-0 text-xs text-gray-500">
                    Se muestran {{ resultadosPermiso.length }} de {{ totalPermiso }}. Escribe más para afinar.
                  </p>
                  <p *ngIf="busquedaPermiso.trim() && !resultadosPermiso.length" class="m-0 text-xs text-gray-500">Ninguna casilla coincide con lo que escribiste.</p>
                </ng-container>
                <button type="button" (click)="cambiarModoPermiso('nuevo')" class="block text-xs text-indigo-600 hover:underline">Crear una casilla nueva</button>
              </div>

              <!-- ¿Botón o toda la parte? -->
              <button *ngIf="form.tipo === 'accion'" type="button" (click)="agrandar()" class="block text-xs text-indigo-600 hover:underline">
                ¿Querías marcar toda esa parte de la pantalla?
              </button>
              <button *ngIf="form.tipo === 'seccion'" type="button" (click)="soloUnBoton()" class="block text-xs text-indigo-600 hover:underline">
                Es solo un botón
              </button>

              <!-- Opciones del equipo técnico (cerrado por omisión; solo acciones) -->
              <details *ngIf="form.tipo === 'accion'" class="text-sm">
                <summary class="cursor-pointer text-xs text-gray-500 hover:text-gray-700">Opciones del equipo técnico</summary>
                <div class="mt-2 space-y-3">
                  <p class="m-0 text-xs text-gray-600">Opcional: además de esconderlo, el servidor rechaza la acción a quien no tenga permiso.</p>
                  <p *ngIf="textoFilasElegida" class="m-0 text-xs text-amber-700">{{ textoFilasElegida }}</p>

                  <label class="flex cursor-pointer items-center gap-2 text-sm">
                    <input type="radio" name="agregar-servidor" [checked]="!form.servidor" (change)="quitarServidor()">
                    <span>No, solo esconderlo</span>
                  </label>
                  <div *ngIf="form.servidor" class="rounded-md bg-indigo-50 px-3 py-2 text-sm">
                    <span class="font-medium">{{ textoLlanoMetodo(form.servidor.metodo) }}</span>
                    <code class="block break-all text-[11px] text-gray-600">{{ form.servidor.metodo }} {{ form.servidor.ruta }}</code>
                  </div>

                  <p *ngIf="cargandoServidor" class="m-0 text-xs text-gray-500"><i class="fas fa-spinner fa-spin mr-1"></i>Cargando la lista...</p>
                  <p *ngIf="errorServidor" class="m-0 text-xs text-red-600">No se pudo cargar la lista. Puedes marcar sin ella con «No, solo esconderlo».</p>

                  <div *ngIf="usadasServidor.length" class="space-y-1">
                    <p class="m-0 text-[11px] font-semibold uppercase tracking-wide text-gray-500">Usadas por esta pantalla</p>
                    <div class="divide-y divide-gray-100 rounded-md border border-gray-200 bg-white">
                      <button type="button" *ngFor="let r of usadasServidor" (click)="elegirServidor(r)" class="block w-full px-3 py-2 text-left hover:bg-indigo-50"
                        [class.bg-indigo-50]="esServidorElegido(r)">
                        <span class="block text-sm">{{ textoLlanoMetodo(r.metodo) }}</span>
                        <code class="block break-all text-[11px] text-gray-500">{{ r.metodo }} {{ r.ruta }}</code>
                      </button>
                    </div>
                  </div>
                  <div *ngIf="parecidasServidor.length" class="space-y-1">
                    <p class="m-0 text-[11px] font-semibold uppercase tracking-wide text-gray-500">Se parecen al nombre de la pantalla</p>
                    <div class="divide-y divide-gray-100 rounded-md border border-gray-200 bg-white">
                      <button type="button" *ngFor="let r of parecidasServidor" (click)="elegirServidor(r)" class="block w-full px-3 py-2 text-left hover:bg-indigo-50"
                        [class.bg-indigo-50]="esServidorElegido(r)">
                        <span class="block text-sm">{{ textoLlanoMetodo(r.metodo) }}</span>
                        <code class="block break-all text-[11px] text-gray-500">{{ r.metodo }} {{ r.ruta }}</code>
                      </button>
                    </div>
                  </div>
                  <p *ngIf="!cargandoServidor && !errorServidor && !usadasServidor.length && !parecidasServidor.length" class="m-0 text-xs text-gray-500">
                    La pantalla no pidió nada que se pueda ofrecer. Prueba con «Buscar en todas».
                  </p>

                  <button *ngIf="!buscarEnTodas" type="button" (click)="abrirBuscadorServidor()" class="text-xs text-indigo-600 hover:underline">Buscar en todas</button>
                  <div *ngIf="buscarEnTodas" class="space-y-2">
                    <input type="text" autocomplete="off" [ngModel]="busquedaServidor" (ngModelChange)="busquedaServidor = $event; filtrarServidor()"
                      placeholder="Escribe una palabra, por ejemplo «tasas»" aria-label="Buscar entre todas las llamadas del servidor"
                      class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
                    <div *ngIf="resultadosServidor.length" class="max-h-56 divide-y divide-gray-100 overflow-y-auto rounded-md border border-gray-200 bg-white">
                      <button type="button" *ngFor="let r of resultadosServidor" (click)="elegirServidor(r)" class="block w-full px-3 py-2 text-left hover:bg-indigo-50"
                        [class.bg-indigo-50]="esServidorElegido(r)">
                        <span class="block text-sm">{{ textoLlanoMetodo(r.metodo) }}</span>
                        <code class="block break-all text-[11px] text-gray-500">{{ r.metodo }} {{ r.ruta }}</code>
                      </button>
                    </div>
                    <p *ngIf="totalServidor > resultadosServidor.length" class="m-0 text-xs text-gray-500">
                      Se muestran {{ resultadosServidor.length }} de {{ totalServidor }}. Escribe más para afinar.
                    </p>
                    <p *ngIf="!cargandoServidor && !errorServidor && busquedaServidor.trim() && !resultadosServidor.length" class="m-0 text-xs text-gray-500">Nada coincide con lo que escribiste.</p>
                  </div>
                  <p class="m-0 text-xs text-gray-500">Queda guardado sin activar; se enciende después en «Lo que también cuida el servidor», al final de esta pestaña.</p>
                </div>
              </details>

              <p *ngIf="errorForm" class="m-0 text-sm text-red-600"><i class="fas fa-exclamation-circle mr-1"></i>{{ errorForm }}</p>

              <div class="flex flex-wrap items-center gap-2 pt-1">
                <button type="button" (click)="marcar()" [disabled]="!form.nombre.trim()"
                  class="inline-flex h-9 items-center justify-center rounded-md bg-indigo-600 px-5 text-sm font-medium text-white transition-colors hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-50">Listo</button>
                <button type="button" (click)="cancelar()"
                  class="inline-flex h-9 items-center justify-center rounded-md border border-gray-300 bg-white px-4 text-sm font-medium transition-colors hover:bg-gray-50">Descartar</button>
                <button *ngIf="form.existente" type="button" (click)="quitarDelFormulario()"
                  class="ml-auto text-sm text-red-600 hover:underline">Quitar marca</button>
              </div>
            </section>

            <!-- Lo que marcaste (todavía sin guardar) -->
            <section *ngIf="!resultado && (estado.acciones.length || estado.secciones.length)" class="space-y-2 border-t border-gray-200 pt-5">
              <h4 class="m-0 text-[11px] font-semibold uppercase tracking-wide text-gray-500">Lo que marcaste</h4>
              <ul class="m-0 list-none space-y-2 p-0">
                <li *ngFor="let a of estado.acciones" class="flex items-start justify-between gap-2 text-sm">
                  <span class="min-w-0">
                    <span class="font-medium">{{ a.casilla }}</span>
                    <span class="block text-xs text-gray-500">{{ detalleMarca(a, false) }}</span>
                  </span>
                  <button type="button" (click)="quitarPendiente(a.id)" [attr.aria-label]="'Quitar ' + a.casilla" class="shrink-0 text-xs text-gray-500 hover:text-red-600 hover:underline">Quitar</button>
                </li>
                <li *ngFor="let s of estado.secciones" class="flex items-start justify-between gap-2 text-sm">
                  <span class="min-w-0">
                    <span class="font-medium">{{ s.nombre }}</span>
                    <span class="block text-xs text-gray-500">{{ detalleMarca(s, true) }}</span>
                  </span>
                  <button type="button" (click)="quitarPendiente(s.id)" [attr.aria-label]="'Quitar ' + s.nombre" class="shrink-0 text-xs text-gray-500 hover:text-red-600 hover:underline">Quitar</button>
                </li>
              </ul>
            </section>
            <p *ngIf="!resultado && !form && !estado.acciones.length && !estado.secciones.length" class="m-0 text-sm text-gray-500">
              Toca un botón o una parte de la pantalla de la izquierda.
            </p>

            <ul *ngIf="problemas.length && !resultado" class="m-0 list-none space-y-1 p-0 text-xs text-amber-700">
              <li *ngFor="let p of problemas"><i class="fas fa-exclamation-triangle mr-1"></i>{{ p }}</li>
            </ul>

            <!-- Lo que ya estaba protegido en esta pantalla -->
            <section *ngIf="marcasGuardadas.length" class="space-y-2 border-t border-gray-200 pt-5">
              <h4 class="m-0 text-[11px] font-semibold uppercase tracking-wide text-gray-500">Ya marcado en esta pantalla</h4>
              <ul class="m-0 list-none space-y-2 p-0">
                <li *ngFor="let m of marcasGuardadas" class="flex items-start justify-between gap-2 text-sm">
                  <span class="min-w-0">
                    <span class="font-medium">{{ tipoMarcaTexto(m.tipo) }}</span>
                    <span *ngIf="m.huella?.etiqueta" class="text-gray-600"> · {{ m.huella.etiqueta }}</span>
                  </span>
                  <button type="button" (click)="quitarGuardada(m)" class="shrink-0 text-xs text-red-600 hover:underline">Quitar</button>
                </li>
              </ul>
            </section>
          </div>

          <!-- 4 · Pie fijo: resumen, quién lo verá y guardar -->
          <div class="shrink-0 space-y-3 border-t border-gray-200 bg-white p-4 lg:max-h-[55%] lg:overflow-y-auto">
            <p *ngIf="errorGuardar" class="m-0 rounded-md border border-red-300 bg-red-50 p-2 text-sm text-red-700">
              <i class="fas fa-exclamation-circle mr-1"></i>{{ errorGuardar }}
            </p>
            <p *ngIf="!resultado" class="m-0 text-sm text-gray-700">{{ resumenAgregar }}</p>

            <!-- ¿Quién lo verá? Dar los permisos nuevos a los roles que hoy ya ven esta pantalla (si no, el vigilante los saca de ella) -->
            <details *ngIf="!resultado && totalPermisos > 0" class="text-sm">
              <summary class="flex cursor-pointer items-center justify-between gap-2">
                <span class="font-medium">¿Quién lo verá?</span>
                <span class="text-xs text-gray-500">{{ resumenQuienVera }}</span>
              </summary>
              <div class="mt-3 space-y-3">
                <p *ngIf="cargandoRoles" class="text-xs text-gray-500">
                  <i class="fas fa-spinner fa-spin mr-1 text-blue-500"></i>Buscando los roles que hoy ven esta pantalla...
                </p>
                <div *ngIf="errorRoles" class="space-y-1 text-xs text-amber-700" role="alert">
                  <p><i class="fas fa-exclamation-triangle mr-1"></i>{{ errorRoles }} Puedes guardar igual, pero ningún rol recibirá los permisos hasta que se los des en la matriz.</p>
                  <button type="button" (click)="cargarRoles()" class="underline">Reintentar</button>
                </div>

                <ng-container *ngIf="!cargandoRoles && !errorRoles">
                  <label for="agregar-dar-roles" class="flex cursor-pointer items-start gap-2 text-sm">
                    <input id="agregar-dar-roles" type="checkbox" [(ngModel)]="darARoles"
                      class="mt-0.5 h-4 w-4 shrink-0 rounded border-gray-300 text-indigo-600 focus:ring-2 focus:ring-ring focus:ring-offset-2">
                    <span class="font-medium">Dar estos permisos a los roles que hoy ya ven esta pantalla</span>
                  </label>
                  <p class="m-0 text-xs" [class.text-gray-500]="darARoles"
                    [class.rounded-md]="!darARoles" [class.border]="!darARoles" [class.border-amber-300]="!darARoles"
                    [class.bg-amber-50]="!darARoles" [class.p-2]="!darARoles" [class.text-amber-900]="!darARoles"
                    [attr.role]="darARoles ? null : 'alert'">
                    <i *ngIf="!darARoles" class="fas fa-exclamation-triangle mr-1"></i>{{ textoSinRoles }}
                  </p>

                  <div *ngIf="darARoles" class="space-y-2">
                    <p *ngIf="!permisosActuales.length" class="m-0 text-xs text-gray-500">
                      Esta pantalla hoy no pide ningún permiso, así que la ven todos los roles.
                    </p>
                    <ul *ngIf="bloqueRoles.lista.length" aria-label="Roles que recibirán los permisos"
                      class="m-0 max-h-48 list-none divide-y divide-gray-200 overflow-y-auto rounded-md border border-gray-200 bg-white p-0">
                      <li *ngFor="let r of bloqueRoles.lista; trackBy: trackPorCodigo">
                        <label class="flex cursor-pointer items-center gap-2 px-2 py-1.5 text-sm hover:bg-gray-50">
                          <input type="checkbox" [checked]="estaElegido(r.code)" (change)="tocarRol(r.code)"
                            class="h-4 w-4 shrink-0 rounded border-gray-300 text-indigo-600 focus:ring-2 focus:ring-ring focus:ring-offset-2">
                          <span class="min-w-0">
                            <span class="font-medium">{{ r.name || r.code }}</span>
                            <span *ngIf="r.department" class="text-xs text-gray-500"> · {{ r.department }}</span>
                          </span>
                        </label>
                      </li>
                    </ul>
                    <p *ngIf="!bloqueRoles.lista.length" class="m-0 text-xs text-gray-500">Hoy ningún rol ve esta pantalla.</p>
                    <p *ngIf="bloqueRoles.lista.length" class="m-0 text-xs text-gray-500">{{ resumenRoles }}</p>
                    <p *ngIf="textoYaTienenTodo" class="m-0 text-xs text-gray-500">{{ textoYaTienenTodo }}</p>

                    <div *ngIf="bloqueRoles.otros.length" class="space-y-1">
                      <label for="agregar-otro-rol" class="block text-xs text-gray-500">Agregar otro rol</label>
                      <select #otroRol id="agregar-otro-rol" (change)="agregarOtroRol(otroRol.value); otroRol.value = ''"
                        class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
                        <option value="">Elige un rol...</option>
                        <option *ngFor="let r of bloqueRoles.otros; trackBy: trackPorCodigo" [value]="r.code">{{ r.name || r.code }}</option>
                      </select>
                    </div>
                  </div>
                </ng-container>
              </div>
            </details>

            <button type="button" (click)="guardar()" [disabled]="guardando || cargandoRoles || !!resultado || problemas.length > 0"
              class="inline-flex h-10 w-full items-center justify-center rounded-md bg-indigo-600 px-4 text-sm font-medium text-white transition-colors hover:bg-indigo-700 disabled:opacity-50">
              <i *ngIf="guardando" class="fas fa-spinner fa-spin mr-2"></i>
              {{ resultado ? 'Guardado' : 'Guardar' }}
            </button>

            <div *ngIf="resultado" class="space-y-2 rounded-md border border-green-300 bg-green-50 p-3">
              <p class="m-0 text-sm font-semibold text-green-800">Listo. Ya están en la Matriz de Permisos.</p>
              <p *ngIf="mensajeAsignados" class="m-0 text-xs"
                [class.text-green-800]="resultado.asignados?.length !== 0" [class.text-amber-700]="resultado.asignados?.length === 0">{{ mensajeAsignados }}</p>
              <p *ngIf="resultado.marcas > 0 || estado.acciones.length || estado.secciones.length" class="m-0 text-xs text-gray-700">
                Los roles a los que se les dio el permiso siguen viendo todo: no se esconde nada para ellos.
                Para comprobarlo, entra con un rol que no tenga este permiso.
              </p>
              <p *ngIf="resultado.protecciones > 0" class="m-0 text-xs text-green-800">
                {{ resultado.protecciones === 1 ? 'La llamada del servidor quedó registrada' : 'Las ' + resultado.protecciones + ' llamadas del servidor quedaron registradas' }} apagadas.
                Para que el servidor las exija, enciéndelas abajo en «Lo que también cuida el servidor».
              </p>
              <div class="flex flex-wrap gap-2">
                <button type="button" (click)="verEnMatriz.emit(); salirPantallaCompleta()"
                  class="inline-flex h-9 items-center justify-center rounded-md border border-gray-300 bg-white px-4 text-sm font-medium transition-colors hover:bg-gray-50">
                  <i class="fas fa-key mr-2"></i>Ver en la matriz
                </button>
                <button type="button" (click)="agregarOtra()"
                  class="inline-flex h-9 items-center justify-center rounded-md border border-gray-300 bg-white px-4 text-sm font-medium transition-colors hover:bg-gray-50">
                  <i class="fas fa-plus mr-2"></i>Agregar otra pantalla
                </button>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  </ng-container>

  <!-- ═══════════════════════════════════════ -->
  <!--  LO QUE TAMBIÉN CUIDA EL SERVIDOR       -->
  <!--  Todas las protecciones (no solo las de esta pantalla). Nacen apagadas; cada una se enciende y se apaga aquí. -->
  <!-- ═══════════════════════════════════════ -->
  <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
    <div class="p-6 space-y-4">
      <div class="flex flex-wrap items-start justify-between gap-3">
        <div class="min-w-0">
          <h3 class="text-base font-semibold"><i class="fas fa-shield-alt mr-2 text-green-600"></i>Lo que también cuida el servidor</h3>
          <p class="text-sm text-muted-foreground mt-1">
            Cada fila es una llamada del servidor que un permiso nuevo puede cuidar. Nacen apagadas: con el interruptor encendido,
            el servidor frena a quien no tenga el permiso.
          </p>
        </div>
        <div class="flex items-center gap-3">
          <span class="text-xs text-gray-500">{{ resumenProtecciones }}</span>
          <button type="button" (click)="cargarProtecciones()" [disabled]="cargandoProtecciones || !!cambiandoProteccion"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-gray-300 bg-white hover:bg-gray-50 h-9 px-4 disabled:opacity-50 transition-colors">
            <i class="fas fa-sync-alt mr-2" [class.fa-spin]="cargandoProtecciones"></i>Actualizar
          </button>
        </div>
      </div>

      <p *ngIf="cargandoProtecciones && !protecciones.length" class="text-sm text-gray-500">
        <i class="fas fa-spinner fa-spin mr-2 text-blue-500"></i>Cargando las llamadas del servidor...
      </p>
      <p *ngIf="errorProtecciones" class="text-sm text-red-600">
        <i class="fas fa-exclamation-triangle mr-2"></i>{{ errorProtecciones }}
      </p>
      <p *ngIf="errorCambio" class="rounded-md border border-red-300 bg-red-50 p-2 text-sm text-red-700" role="alert">
        <i class="fas fa-exclamation-circle mr-1"></i>{{ errorCambio }}
      </p>

      <p *ngIf="!cargandoProtecciones && !errorProtecciones && !protecciones.length" class="text-sm text-gray-500">
        Todavía no hay ninguna. Aparecen aquí cuando guardas una acción con una ruta en «Qué cuida también en el servidor».
      </p>

      <input *ngIf="hayFiltroProtecciones" type="text" autocomplete="off"
        [ngModel]="busquedaProtecciones" (ngModelChange)="alEscribirFiltroProtecciones($event)"
        placeholder="Buscar por llamada, permiso o estado, por ejemplo «tasas» o «apagado»" aria-label="Buscar entre las llamadas del servidor"
        class="flex h-9 w-full max-w-xl rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
      <p *ngIf="hayFiltroProtecciones && busquedaProtecciones.trim() && !proteccionesVisibles.length" class="text-xs text-gray-500">
        Ninguna llamada coincide con lo que escribiste.
      </p>

      <ul *ngIf="proteccionesVisibles.length" class="max-h-[28rem] overflow-y-auto divide-y divide-gray-200 rounded-md border border-gray-200">
        <li *ngFor="let f of proteccionesVisibles; trackBy: trackPorId" class="px-3 py-3 space-y-3">
          <div class="flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
            <div class="min-w-0 space-y-0.5">
              <code class="block text-xs break-all text-gray-700">{{ f.metodo }} {{ f.ruta }}</code>
              <p class="text-sm">
                <span class="text-gray-500">Exige: </span>
                <span class="font-medium" [title]="f.permiso">{{ f.donde }}</span>
              </p>
            </div>
            <div class="flex shrink-0 items-center gap-3">
              <i *ngIf="cambiandoProteccion === f.id" class="fas fa-spinner fa-spin text-blue-500" aria-hidden="true"></i>
              <span class="inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium"
                [class.border-green-300]="f.activo" [class.bg-green-50]="f.activo" [class.text-green-700]="f.activo"
                [class.border-gray-300]="!f.activo" [class.bg-gray-50]="!f.activo" [class.text-gray-600]="!f.activo">{{ f.estado }}</span>
              <button type="button" role="switch" [attr.aria-checked]="f.activo" (click)="tocarInterruptor(f)"
                [disabled]="!!cambiandoProteccion"
                [attr.aria-label]="(f.activo ? 'Apagar' : 'Encender') + ' la protección de ' + f.metodo + ' ' + f.ruta"
                class="relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:opacity-50"
                [class.bg-green-600]="f.activo" [class.bg-gray-300]="!f.activo">
                <span class="inline-block h-4 w-4 rounded-full bg-white shadow transition-transform"
                  [class.translate-x-6]="f.activo" [class.translate-x-1]="!f.activo"></span>
              </button>
            </div>
          </div>

          <!-- Antes de ENCENDER: confirmación dentro de la página (apagar no pide nada) -->
          <div *ngIf="proteccionPorEncender?.id === f.id" role="group" aria-label="Confirmar que se enciende la protección"
            class="rounded-md border border-amber-300 bg-amber-50 p-3 space-y-3">
            <p class="text-sm text-amber-900">{{ textoEncender(f.nombre) }}</p>
            <div class="flex flex-wrap items-center gap-2">
              <button type="button" (click)="confirmarEncender()" [disabled]="!!cambiandoProteccion"
                class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-green-600 text-white hover:bg-green-700 h-9 px-4 disabled:opacity-50 transition-colors">
                <i *ngIf="cambiandoProteccion === f.id" class="fas fa-spinner fa-spin mr-2"></i>Encender
              </button>
              <button type="button" (click)="cancelarEncender()" [disabled]="!!cambiandoProteccion"
                class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-gray-300 bg-white hover:bg-gray-50 h-9 px-4 disabled:opacity-50 transition-colors">
                Cancelar
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
